import { SVGProps } from "react";

export const PauseIcon = (props: SVGProps<SVGSVGElement>) => (
 <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.25 4.39583C0.25 2.3823 1.8823 0.75 3.89583 0.75C5.90937 0.75 7.54167 2.3823 7.54167 4.39583V14.6042C7.54167 16.6177 5.90937 18.25 3.89583 18.25C1.8823 18.25 0.25 16.6177 0.25 14.6042V4.39583Z" fill="currentColor"/>
    <path d="M10.4584 4.39583C10.4584 2.3823 12.0907 0.75 14.1042 0.75C16.1177 0.75 17.75 2.3823 17.75 4.39583V14.6042C17.75 16.6177 16.1177 18.25 14.1042 18.25C12.0907 18.25 10.4584 16.6177 10.4584 14.6042V4.39583Z" fill="currentColor"/>
  </svg>
);
